import "flag-icon-css/css/flag-icon.min.css";
import Router from "./router";

export * from "./shared";

export default Router;